<ng-template #noDataRef>
  <p class="noDataContainer">{{ 'teamPage.empty' | translate }}</p>
</ng-template>

<placeme-layout-seo [seo]="seo" [category]="team?.__typename">
  <div
    [style.backgroundImage]="'url(' + team?.displayProfile?.family?.seo?.image?.url + ')'"
    [style.backgroundColor]="team?.displayProfile?.family?.backgroundColor"
    class="jumbotron"
  ></div>
  <section class="main-content">
    <div class="profile">
      <div class="profile__header">
        <placeme-team-card class="profile__header__card" [team]="team"></placeme-team-card>
        <header class="profile__header__content">
          <img
            class="profile__header__content__avatar"
            [src]="team | avatarUrl"
            [alt]="team | displayTeamMember"
            [title]="team | displayTeamMember"
          />
          <h2 class="profile__header__content__job" [ngStyle]="{ color: team?.displayProfile?.family?.backgroundColor }">
            {{ team?.jobTitle || team?.displayProfile?.family?.name }}
          </h2>
          <h1 class="profile__header__content__name">{{ team?.consent?.nameDisplay ? team?.seo.title : 'Anonyme' }}</h1>
          <p *ngIf="team?.consent?.nameDisplay" class="profile__header__content__mood">{{ team?.seo?.description }}</p>
          <div class="profile__header__content__techno">
            <div
              *ngFor="let icon of team?.seo.icons"
              [style.backgroundImage]="'url(' + icon.url + ')'"
              class="profile__header__content__techno__item"
            ></div>
          </div>
        </header>
      </div>
      <section class="profile__personality">
        <h2 class="profile__personality__title">{{ 'teamPage.personality' | translate }}</h2>
        <a *ngIf="team?.personality; else noDataRef" class="card" target="_blank" href="https://www.16personalities.com/">
          <div class="card__img">
            <img [src]="team?.personality?.image?.url" [alt]="team?.personality?.name" [title]="team?.personality?.name" />
          </div>
          <div class="card__container">
            <h3 class="card__container__title">{{ team?.personality?.name }}</h3>
            <p class="card__container__description">{{ team?.personality?.description }}</p>
          </div>
        </a>
      </section>

      <section class="profile__posts">
        <h2 class="profile__posts__title">{{ 'teamPage.posts' | translate }}</h2>
        <div class="posts">
          <ng-container *ngIf="team?.blogs?.length; else noDataRef">
            <placeme-blog-card *ngFor="let blog of team.blogs; trackBy: trackBySlug" [blog]="blog"></placeme-blog-card>
          </ng-container>
        </div>
      </section>

      <section class="profile__testimonials">
        <h2 class="profile__testimonials__title">{{ 'teamPage.testimonials' | translate }}</h2>
        <div class="testimonials" *ngIf="team?.testimonials?.length; else noDataRef">
          <blockquote class="testimonial" *ngFor="let testimonial of team?.testimonials">
            <div class="testimonial__headerContainer">
              <div class="testimonial__headerContainer__avatar">
                <img [src]="testimonial?.avatar?.url" [alt]="testimonial?.name" [title]="testimonial?.name" />
              </div>
              <div class="testimonial__headerContainer__header">
                <h3 class="testimonial__headerContainer__header__name">{{ testimonial?.name }}</h3>
                <p class="testimonial__headerContainer__header__job">{{ testimonial?.job }}</p>
              </div>
            </div>
            <p class="testimonial__text">{{ testimonial?.comment }}</p>
          </blockquote>
        </div>
      </section>
    </div>
  </section>
</placeme-layout-seo>
